import { createElement } from 'react';
// @ts-ignore

/**
 * Represents one of the following:
 *
 * - React Element
 * - Render Prop (that takes arguments of type `P`)
 *
 * Null is a valid React Element. Undefined is not.
 *
 * @see RenderProp
 */ // prettier-ignore
/**
 * You don't have to use this function, as long as you test slot content against undefined instead of truthy.
 *
 * This function implementation will never change.
 */
export function isDefinedSlot(slotContent) {
  return slotContent !== undefined;
}

/**
 * Renders a Slot value. **Please understand that `null` is a valid Slot value.**
 *
 * If:
 * - the value is a render prop, call it with the props passed.
 * - the value is a ReactElement or `null`, return it
 *
 * @param slotContent The render prop to call or react elements to pass through.
 * @param props The props to pass to a render prop slotContent.
 *
 * @example
 * ```
 * const myElement = <div>
 *   {isDefinedSlot(slot) ? renderSlot(slot, { value: 5 }) : <span>5</span>}
 * </div>;
 * ```
 */
export function renderSlot(slotContent, props) {
  if (typeof slotContent === 'function') {
    return slotContent(props);
  } else {
    return slotContent;
  }
}

/**
 * @deprecated Use isDefinedSlot and renderSlot instead of this.
 */
export function renderSlotWithRenderPropFallback(slotContent, fallback, props) {
  if (typeof slotContent === 'function') {
    return slotContent(props);
  } else if (slotContent !== undefined) {
    return slotContent;
  } else {
    return fallback(props);
  }
}

/**
 * Render slot, and use fallback component if needed
 */
export function renderSlotWithComponentFallback(slotContent, fallback, props) {
  if (typeof slotContent === 'function') {
    return slotContent(props);
  } else if (slotContent !== undefined) {
    return slotContent;
  } else {
    return /*#__PURE__*/createElement(fallback, props);
  }
}

/**
 * Render RenderProp, and use fallback component if needed
 */
export function renderPropWithComponentFallback(renderProp, fallback, props) {
  if (renderProp !== undefined) {
    return renderProp(props);
  } else {
    return /*#__PURE__*/createElement(fallback, props);
  }
}
//# sourceMappingURL=slot.js.map